"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var AutotextController = /** @class */ (function (_super) {
    __extends(AutotextController, _super);
    function AutotextController($scope, $interpolate, book) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.$interpolate = $interpolate;
        _this.setValue();
        $scope.$watch(function () { return book; }, function () { _this.setValue(); }, true);
        return _this;
    }
    AutotextController.prototype.setValue = function () {
        this.form.value = this.$interpolate(this.value)(this.book);
        this.book.set(this.prefix, this.id, this.form.value);
    };
    return AutotextController;
}(form_1.FormOptionController));
exports.AutotextController = AutotextController;
function AutotextDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/autotext.html',
        controller: AutotextController,
        controllerAs: 'autotextCtrl'
    };
}
exports.AutotextDirective = AutotextDirective;
